<template>
    <div v-if="chatUser" ref="chat-user" class="chat-user" :class="{ premium: me.is_premium && user.$$premium }">
        <div class="basic flex-row">
            <div
                @click="onClickChatUserImage"
                class="img-profile animate-size cursor-pointer flex-wrap m-r-16"
                v-lazy:background-image="coverImg"
            >
                <div v-if="isPrivacy" class="privacy-status flex-row">
                    <i class="material-icons flex-wrap security">security</i>
                    <div class="privacy-remain" v-html="privacyRemain" />
                </div>
                <div
                    v-if="(me.is_premium && !chat.expire_at && myPremium) || (me.is_premium && isPremiumSales())"
                    class="bottom-overlay"
                >
                    <div v-if="myPremium && remainTime < 0" class="premium-remain">
                        <div v-html="remainDay != null ? `${remainDay}일 남음` : ''" />
                        <button @click="premiumExtend">1일 연장하기</button>
                    </div>
                    <div v-else class="premium-remain">
                        <div class="end" v-html="'기간 종료'" />
                        <button @click="closeChat">프리미엄 종료</button>
                    </div>
                </div>
            </div>
            <div class="flex-fill">
                <UserProfile :hideDistance="true" :user="chatUser" :chat="chat" :hideBookmark="false" />
                <UserStyles v-show="chatUser.style" class="fourline" :user="chatUser" :tableOnly="true" />
            </div>
        </div>
        <i
            @click="toggleExpand"
            @mouseover="showSbExpand = true"
            @mouseleave="showSbExpand = false"
            class="zmdi toggle-expand"
            :class="expanded ? 'zmdi-chevron-up' : 'zmdi-chevron-down'"
        />
        <div v-show="expanded" class="detail flex">
            <div :style="{ display: 'flex' }">
                <div class="flex-fill">
                    <UserIntro :profile="chatUser.profile" />
                    <JobIntro :profile="chatUser.profile" />
                </div>
                <UserStyles class="flex-fill" v-show="expanded" :user="chatUser" />
            </div>
            <div class="hr" />
            <LikeTags :user="chatUser" />
            <div class="hr" />
            <DatingStyles :user="chatUser" />
        </div>
    </div>
</template>

<script>
import UserIntro from '@/components/common/UserIntro'
import JobIntro from '@/components/common/JobIntro'
import UserStyles from '@/components/common/UserStyles'
import LikeTags from '@/components/common/LikeTags'
import DatingStyles from '@/components/common/DatingStyles'
import productService from '@/services/product'

export default {
    name: 'user',
    components: {
        UserIntro,
        JobIntro,
        UserStyles,
        LikeTags,
        DatingStyles,
    },
    computed: {
        user() {
            return this.chat.user
        },
        chat() {
            return this.$store.getters.chat || {}
        },
        coverImg() {
            return this.user.photo_url
        },
        me() {
            return this.$store.getters.agent
        },
        myPremium() {
            if (this.user.$$premium) {
                const premium = this.$options.filters.hasProduct(this.user, 'premium')
                return this.$store.getters.agent.id === premium.agent_id
            }
            return false
        },
        agentId() {
            return this.me.id
        },
        premiumProduct() {
            if (this.user.$$premium) {
                const premium = this.$options.filters.hasProduct(this.user, 'premium')
                return premium
            }
            return null
        },
        isPrivacy() {
            return this.user.$$privacy
        },
        privacyRemain() {
            if (this.user.$$privacy) {
                const privacy = this.$options.filters.hasProduct(this.user, 'privacy')
                return `${this.$moment(privacy.valid_until).diff(this.$moment(), 'days')}일 남음`
            } else {
                return null
            }
        },
    },
    data: () => ({
        expanded: null,
        showSbExpand: false,
        chatUser: {},
        remainDay: null,
        remainTime: null,
    }),
    watch: {
        user(newVal, oldVal) {
            if (newVal && oldVal && newVal.id !== oldVal.id) this.init()
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            this.chatUser = await this.$store.dispatch('loadUserDetail', { userId: this.user.id })
            this.premiumRemain()
        },

        toggleExpand() {
            this.expanded = !this.expanded ? 'expanded' : null
        },
        async onClickChatUserImage() {
            const photos = await this.$store.dispatch('loadUserImages', this.user.id)
            if (!photos) return

            this.$modal.images({
                images: photos.map(p => p.url),
            })
        },
        async closeChat(event) {
            event.stopPropagation()
            const onConfirm = async () => {
                try {
                    // const resp = await chatService.delete(this.chat.id)
                    const resp = await productService.updatePremiumEnd({
                        product_id: this.premiumProduct.id,
                        chat_id: this.chat.id,
                    })
                    this.$toast.success(resp.msg)
                    // this.$store.commit('removeChat', this.chat.id)
                } catch (e) {
                    this.$toast.error(e.data)
                }
            }

            this.$modal
                .basic({
                    body: '프리미엄 주선을 종료합니다.',
                    buttons: [
                        {
                            label: 'CANCEL',
                            class: 'btn-default',
                        },
                        {
                            label: 'CONFIRM',
                            class: 'btn-primary',
                        },
                    ],
                })
                .then(idx => {
                    if (idx === 1) {
                        onConfirm()
                    }
                })
        },
        async premiumExtend() {
            event.stopPropagation()
            const premiumProductId = this.premiumProduct.id
            const onConfirm = async () => {
                try {
                    const resp = await productService.update(premiumProductId)
                    this.$toast.success(resp.msg)
                    this.remainDay += 1
                    // this.$store.commit('removeChat', this.chat.id)
                } catch (e) {
                    this.$toast.error(e.data)
                }
            }

            this.$modal
                .basic({
                    body: '프리미엄을 1일 연장하시겠습니까?',
                    buttons: [
                        {
                            label: 'CANCEL',
                            class: 'btn-default',
                        },
                        {
                            label: 'CONFIRM',
                            class: 'btn-primary',
                        },
                    ],
                })
                .then(idx => {
                    if (idx === 1) {
                        onConfirm()
                    }
                })
        },
        premiumRemain() {
            if (this.user.$$premium) {
                const premium = this.$options.filters.hasProduct(this.user, 'premium')
                this.remainTime = this.$moment() - this.$moment(premium.valid_until)
                this.remainDay = this.$moment(premium.valid_until).diff(this.$moment(), 'days')
            }
        },
        isPremiumSales() {
            // 상담사 에이전트 아이디를 하드코딩으로 박아놓음. 아직은 프로퍼티 추가하기 그래서..
            // 나중에 프로퍼티 추가해서 만들수도
            // 유저쪽 상담사 워딩도 하드코딩임. 수정 필요

            const premiumSalesAgent = [17743, 17744, 17747, 17751]
            if (this.agentId && premiumSalesAgent.find(i => i === this.agentId)) {
                return true
            } else {
                return false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.hr {
    width: 100%;
    height: 1px;
    margin: 24px 0;
    background: $grey-02;
}
.privacy-status {
    width: 80px;
    height: 22px;
    border-radius: 14px;
    background-color: $blue-facebook;
    margin-top: 6px;
    margin-left: 6px;
    padding: 3px 12px 4px 8px;
    align-items: center;

    .security {
        font-size: 14px;
        margin-right: 4px;
        color: white;
    }
    .privacy-remain {
        color: white;
        font-size: 10px;
        @include f-bold;
    }
}
</style>
